module.exports = "<div id=\"noDevices\" class=\"containerFlex\">\r\n    <div>\r\n        <img src=\"../../assets/img/icons/no-devices-installed.svg\">\r\n    </div>\r\n    <div id=\"noDevicesMessage\">\r\n        <b>{{'You do not have any devices installed yet' | translate}}.</b> <br>\r\n        <b>{{'Learn more about our devices!' | translate}}</b>\r\n    </div>\r\n    <input type=\"submit\" value=\"SHOW ME RE:DY DEVICES\" (click)=\"goToDevicesAbout()\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-devices/no-devices.component.html
// module id = ./src/app/shared/components/no-devices/no-devices.component.html
// module chunks = main